"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HeadBucketInput_1 = require("./HeadBucketInput");
var HeadBucketOutput_1 = require("./HeadBucketOutput");
var NoSuchBucket_1 = require("./NoSuchBucket");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.HeadBucket = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "HeadBucket",
    http: {
        method: "HEAD",
        requestUri: "/{Bucket}"
    },
    input: {
        shape: HeadBucketInput_1.HeadBucketInput
    },
    output: {
        shape: HeadBucketOutput_1.HeadBucketOutput
    },
    errors: [
        {
            shape: NoSuchBucket_1.NoSuchBucket
        }
    ]
};
//# sourceMappingURL=HeadBucket.js.map